<template>
  <div class="new-home-main">
    <el-button
      class="new-home-about-us"
      type="text"
      @click="turnToAboutUs"
    >关于我们</el-button>
    <div class="new-home-header">
      <div v-if="!isLogin">
        <el-button
          type="text"
          @click="login"
        >登录</el-button>
        <el-button
          type="text"
          @click="reg"
        >注册</el-button>
      </div>
      <div v-else>
        <span class="new-home-login-text">欢迎&nbsp;{{ userInfo.TrueName }}</span>
        <el-button
          type="text"
          @click="logout"
        >退出</el-button>
      </div>
    </div>
    <a href="javascript:void(0)">
      <img
        class="new-home-turn-to-bigscreen"
        src="../../assets/img/数据可视化平台@2x.png"
        @click="turnToBigScreen"
    ></a>
    <div class="new-home-body">
      <img src="../../assets/img/text.png">
      <div class="new-home-search-input">
        <el-input
          v-model="searchData"
          placeholder="请输入内容"
          @keyup.enter.native="search"
        >
          <el-select
            slot="prepend"
            v-model="searchSelect"
            placeholder="请选择"
          >
            <el-option
              v-for="(i,index) in searhTypeOptions"
              :key="index"
              :value="i.value"
              :label="i.label"
            />
          </el-select>
          <el-button
            slot="append"
            @click="search"
          >搜索
          </el-button>
        </el-input>
        <div />
        <span class="new-home-text">
          本库按照1978-2018年中国改革开放历程进行
          <a
            class="new-home-red-text"
            @click="jumpToLibary('')"
          >大事编年</a>
          史料梳理，其中包括
          <a
            class="new-home-red-text"
            @click="jumpToLibary('/historyAccount/0')"
          >口述改革历史</a>
          和
          <a
            class="new-home-red-text"
            @click="jumpToLibary('/historyObject/0')"
          >改革历史见证实物</a>
          专栏。改革开放四十年大事纷纭，史料诸多，本库将坚持不断完善编年史料梳理，也希望有志之士参与我们一起完善补充，见证改革历史，客观反应改革历史，服务改革开放伟大事业。
        </span>
      </div>
    </div>
    <div class="new-home-footer">
      <span>主办单位：中国（海南）改革发展研究院 琼10200862号</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { globalService } from '@/service/globalService'
export default {
  data () {
    return {
      searchData: '',
      searchSelect: 'titleAndMainContent',
      // 搜索类型
      searhTypeOptions: window.dictionaryConfig.searhTypeOptions
    }
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin',
      userInfo: state => state.account.historyUserInfo
    })
  },
  methods: {
    ...mapMutations({
      login: 'LOGIN_SHOW',
      reg: 'REGISTER_SHOW'
    }),
    ...mapActions({
      logout: 'userLogout'
    }),
    search () {
      this.$router.push({ name: 'historyArea', query: { type: this.searchSelect, content: this.searchData } })
    },
    jumpToLibary (url) {
      if (!this.isLogin) {
        globalService.showErrNofify('暂无访问权限，请先登录！')
        setTimeout(() => {
          this.login()
        }, 400)
        return
      }
      this.$router.push(url)
    },
    turnToBigScreen () {
      window.open('http://datacenter.reformdata.org:8080/#/nav')
    },
    turnToAboutUs () {
      let id = 'abd44117-1434-4f2f-a86d-aec7739024c9'
      let { href } = this.$router.resolve({
        path: '/aboutUs/' + id
      })
      window.open(href)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/history/history-home.out.vue